import React, { useState, useEffect } from "react";
import {
  Alert,
  Snackbar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,IconButton
} from "@mui/material";
import { Outlet, Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../styles/login.scss";
import "../../dataEntry/styles/DataEntry.scss";
import logo from "../assets/images/avyantra_logo.png";
import prelogo from "../assets/images/presco_logo.png";
import { login, logindetailsget } from "../reducers/loginThunk";
import { ToastContainer, toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { INVALID_CREDENTIALS } from "../../dataEntry/utils/mockData";
import { resetPassword } from "../reducers/loginThunk";
import {
  setErrorMessage,
  setsuccessMessage,
} from "../../dataEntry/reducers/patientDataThunk";
import Loginform from "./loginform";
import { PASSWORD_MISMATCH } from "../../dataEntry/utils/mockData";

const NewPassword = (props) => {
  const [loginForm, setLoginForm] = React.useState({});
  const [profileData, setProfileData] = useState({
    password: "",
    showPassword: false,
    showConfirmPassword:false,
  });

  const [showConfirmPasswordErrorMessage, setShowConfirmPasswordErrorMessage] =
    useState();
  const [showPasswordErrorMessage, setShowPasswordErrorMessage] = useState();
  const [errorFields, setErrorFields] = useState({});

  const verifyKey = useParams();
  const passcode = verifyKey.id;

  const user = useSelector((state) => state.user.userProfile);
  const patient = useSelector((state) => state.patient);
  const [errMsg, setErrMsg] = React.useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickShowPassword = () => {
    setProfileData({ ...profileData, showPassword: !profileData.showPassword });
  };
  
  const handleClickShowConfirmPassword = () => {
    setProfileData({ ...profileData, showConfirmPassword: !profileData.showConfirmPassword });
  };

  useEffect(() => {
    if (patient.errorMessage) {
      setTimeout(() => {
        dispatch(setErrorMessage(""));
      }, 1000);
    }
  }, [patient.errorMessage]);

  useEffect(() => {
    if (patient.successMessage) {
      setTimeout(() => {
        dispatch(setsuccessMessage(""));
      }, 1000);
    }
  }, [patient.successMessage]);

  const verifyConfirmPassword = (event) => {
    const Passwordcheck =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!Passwordcheck.test(event.target.value)) {
      setShowConfirmPasswordErrorMessage(
        "Password must contain a minimum of eight characters, including at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
      setErrorFields(
        Object.assign({}, errorFields, { confirm_password: true })
      );
      FormChange(event);
    } else {
      FormChange(event);
      setErrorFields(
        Object.assign({}, errorFields, { confirm_password: false })
      );
      setShowConfirmPasswordErrorMessage("");
    }
  };

  const verifyPassword = (event) => {
    const Passwordcheck =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!Passwordcheck.test(event.target.value)) {
      setShowPasswordErrorMessage(
        "Password must contain a minimum of eight characters, including at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
      setErrorFields(Object.assign({}, errorFields, { password: true }));
      FormChange(event);
    } else {
      FormChange(event);
      setErrorFields(Object.assign({}, errorFields, { password: false }));
      setShowPasswordErrorMessage("");
    }
  };

  const FormChange = (event) => {
    const fieldname = event.target.name;
    const fieldvalue = event.target.value;
    const newFormData = { ...profileData };
    newFormData[fieldname] = fieldvalue;
    setProfileData(newFormData);
  };

  const FormSubmit = (event) => {
    event.preventDefault();

    const newFormData = { ...profileData };
    newFormData.passcode = passcode;
    if (newFormData.password == newFormData.confirm_password) {
      const req = { newFormData };
      dispatch(resetPassword(newFormData)).then((resdata) => {
        if (resdata.payload.status != "200") {
          toast.error(resdata.payload.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          //dispatch(setErrorMessage(resdata.payload.message));
        } else {
          //dispatch(setsuccessMessage(resdata.payload.message));
          toast.success(resdata.payload.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          sessionStorage.removeItem("access_token");
          sessionStorage.removeItem("user");
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
      });
    } else {
      toast.error(PASSWORD_MISMATCH, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      //dispatch(setErrorMessage(PASSWORD_MISMATCH));
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Grid container>
        <Grid item xs={12} sm={12}>
        <Grid container style={{
              marginTop: "3%",
            }}>
           
            <Grid item xs={12} sm={12}>
              <img src={prelogo} className="pre_img" />
              <div className="pre_caption">
                Neonatal Sepsis Prediction Platform
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
        <Box className="login-container">
          <Grid
            container
            spacing={2}
            justifyContent={"center"}
            alignItems={"center"}
            style={{
              marginTop: "3%",
            }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={3}
              //columns={{ xs: 1, sm: 12, md: 6 }}
            >
              <Card variant="outlined" className="login_radius">
                <CardContent>
                  <p className="login_welcome">Set new password</p>
                  <p className="forgot_cont">
                    Your new password must be different from previous passwords
                  </p>
                  <form id="mother-medical-form" onSubmit={FormSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <label
                          htmlFor="New Password"
                          className="dataentry_label"
                          style={{ display: "block" }}
                        >
                          Password
                        </label>
                        <TextField
                          id="password"
                          name="password"
                          label=""
                          variant="outlined"
                          className="dataentry_input2"
                          size="small"
                          //type={"password"}
                          type={profileData.showPassword ? "text" : "password"}
                          value={profileData.password}
                          //onChange={FormChange}

                          error={
                            errorFields.password && showPasswordErrorMessage
                          }
                          //helperText={showErrorMessage}
                          errorText={showPasswordErrorMessage}
                          helperText={
                            errorFields.password && showPasswordErrorMessage
                              ? showPasswordErrorMessage
                              : ""
                          }
                          
                        InputProps={{
                          inputProps: {
                            maxLength:15,
                            minLength: 8,
                          },
                          endAdornment: (
                            <IconButton
                              onClick={() => handleClickShowPassword()}
                            >
                              {profileData.showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          ),
                        }}
                          onChange={(e) => {
                            FormChange(e);
                            verifyPassword(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} sm={12}>
                        <label
                          htmlFor="Confirm New Password"
                          className="dataentry_label"
                          style={{ display: "block" }}
                        >
                          Confirm Password
                        </label>
                        <TextField
                          id="confirm_password"
                          name="confirm_password"
                          label=""
                          variant="outlined"
                          className="dataentry_input2"
                          size="small"
                          //type={"password"}
                          error={
                            errorFields.confirm_password &&
                            showConfirmPasswordErrorMessage
                          }
                          
                          type={profileData.showConfirmPassword ? "text" : "password"}
                          value={profileData.confirm_password}

                        InputProps={{
                          inputProps: {
                            maxLength:15,
                            minLength: 8,
                          },
                          
                          endAdornment: (
                            <IconButton
                              onClick={() => handleClickShowConfirmPassword()}
                            >
                              {profileData.showConfirmPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          ),
                        }}
                          //helperText={showErrorMessage}
                          errorText={showConfirmPasswordErrorMessage}
                          helperText={
                            errorFields.confirm_password &&
                            showConfirmPasswordErrorMessage
                              ? showConfirmPasswordErrorMessage
                              : ""
                          }
                          //onChange={FormChange}
                          onChange={(e) => {
                            FormChange(e);
                            verifyConfirmPassword(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "10%",
                          marginBottom: "10%",
                        }}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          className="sendcode_button"
                        >
                          Confirm
                        </Button>
                      </Grid>
                    </Grid>

                    {/*  <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <p>
                      Don't have an account?
                      <Link to="/Signup">Sign Up</Link>
                    </p>
                  </Grid>
                </Grid> */}
                  </form>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
        <div className="signUpBg">
        <Grid className="copy-posi">
          <p className="Copyright">
            Copyright © 2019-2024 Avyantra Health Technologies. All Rights
            Reserved
          </p>
        </Grid>
      </div>
      {patient.errorMessage && (
        <Snackbar
          open={patient.errorMessage}
          autoHideDuration={1000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="error" variant="filled">
            {patient.errorMessage}
          </Alert>
        </Snackbar>
      )}
      {patient.successMessage && (
        <Snackbar
          open={patient.successMessage}
          autoHideDuration={1000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="success" variant="filled">
            {patient.successMessage}
          </Alert>
        </Snackbar>
      )}
    </React.Fragment>
  );
};

export default NewPassword;
